export default __webpack_public_path__ + "static/media/cricket.43a894e3.png";